import axios from 'axios'
import { config } from '@/utils/request'

const _config = {
  baseURL: config.baseURL,
  headers: {
    'Content-Type': 'multipart/form-data'
    // 'token': config.headers.token
  }
}

axios.interceptors.response.use(response => {
  let res = response.data
  if (res.code === 1 || res.code === '1') {
    return res
  } else {
    return Promise.reject(res)
  }
}, error => {
  return Promise.reject(error)
})

export function uploadImage(file) {
  const url = '/common/upload'
  let fd = new FormData()
  fd.append('file', file, file.name)
  return axios.post(url, fd, _config)
}



// WEBPACK FOOTER //
// ./src/api/upload.js